module.exports = __webpack_public_path__ + "img/Penang.2a8a0398.png";